<template>
    <div>
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="search"></v-text-field>
        </v-toolbar>
         <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="logs"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <!-- <v-icon small @click="updateItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteVehicle(props.item)">delete</v-icon> -->

        </td>
        <td
          class="text-xs-center"
          @click="calculateDistance(props.item)"
        >{{formatDate(props.item.startTime)}}</td>
        <td
          class="text-xs-center"
        >{{props.item.startCoordinates}}</td>
        <td
          class="text-xs-center"
        >{{formatDate(props.item.endTime)}}</td>
        <td
          class="text-xs-center"
        >{{props.item.startCoordinates}}</td>
        <td
          class="text-xs-center"
        >{{props.item.driver.name}} {{props.item.driver.surname}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
    </div>
</template>
<script>
import Api from '@/services/Api'
import dateformat from "dateformat";
export default {
    data(){
        return {
            headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Start Time",
          align: "center",
          value: "startTime"
        },
        {
          text: "Start Place",
          align: "center",
          value: "startPlace"
        },
        {
          text: "End Time",
          align: "center",
          value: "endTime"
        },
        {
          text: "End Place",
          align: "center",
          value: "endPlace"
        },
        {
          text: "Driver",
          align: "center",
          value: "driver.name"
        }
      ],
            logs: [],
            search: ''
        }
    },
    created(){
        this.fetchLogs()
    },
    methods: {
        calculateDistance(item){
            Api().post('/logBook/calculateDistance', item.route).then(res=>{
                console.log(res.data)
            })
        },
        fetchLogs(){
            Api().get('/logBook').then(res=>{
                this.logs = res.data
            })
        },
        formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy HH:MM");
      } else {
        null;
      }
    },
    }
}
</script>